import { useHttpClientDispatchable } from "../../../../common/modules/httpClient/hooks/useHttpClientDispatchable";
import { RequestMethodEnum } from "../../../../common/modules/httpClient/enums/RequestMethodEnum";

export const useDeleteInitiativeService = (objectiveId: number) => {
  return useHttpClientDispatchable({
    url: `/objective/${objectiveId}/initiative/`,
    method: RequestMethodEnum.DELETE,
  });
};
